module.exports = {"320114001":"雨花街道","320114002":"赛虹桥街道","320114004":"西善桥街道","320114005":"板桥街道","320114006":"铁心桥街道","320114007":"梅山街道","320114400":"雨花经济开发区","320114401":"板桥新城","320114402":"中国（南京）软件谷"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320114.json
// module id = 833
// module chunks = 0